import React from 'react';

const Error = function (props) {
    return (
        <div className={"alert alert-error"}>
            {props.msg}
            {props.onButtonClick && (
                <div>
                    <button disabled={props.disabled} className="button button-outline" onClick={props.onButtonClick}>{props.buttonLabel}</button>
                </div>
            )}
        </div>
    );
}

export default Error;